export { default } from '@/src/features/paywall/screens/RedeemVoucherScreen'
